module.exports = __webpack_public_path__ + "static/media/1417951363.170bf7b8.ttf";